export function buildIframeSrc(
  objectUrl: string,
  page?: number,
  zoom?: number,
): string {
  const pageFragment = page ? `page=${page}&` : '';
  const viewFragment = zoom ? `zoom=${zoom}` : 'view=fitH';
  return `${objectUrl}#${pageFragment}${viewFragment}`;
}

export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 5;

export function clampScale(scale: number): number {
  return Math.min(Math.max(scale, MIN_ZOOM), MAX_ZOOM);
}

export function toValidPageNumber(page?: number | string): number | undefined {
  if (page == null || page === '') return undefined;
  const parsed = Math.floor(Number(page));
  if (!Number.isFinite(parsed) || parsed < 1) return undefined;
  return parsed;
}
